import React from 'react';
import PropTypes from 'prop-types';

import { Redirect, Route} from 'react-router-dom';

export const PublicRoute = ({
    isAutenticated,
    component:Component,
    userRole,
    merchantId,
    ...rest
}) => {

    return (
        <Route {...rest}
            component={(props)=> {
                if (!isAutenticated) {
                    return <Component {...props}/>;
                }
                if (userRole === 'merchant') {
                    return <Redirect to={`/merchantsDetails/${merchantId}`}/>;
                }
                return <Redirect to="/"/>;         
                // ?(<Component {...props}/>)
                // :(<Redirect to="/"/>)
            }

            }
        />
    )
}


PublicRoute.propTypes = {
    isAutenticated:PropTypes.bool.isRequired,
    component:PropTypes.func.isRequired,
    userRole: PropTypes.string,
    merchantId: PropTypes.number
}
